import { useSearchParams, useLocation } from "react-router-dom"
import { DailyPage } from "@/features/daily"
import { WeeklyPage } from "@/features/weekly"
import { MonthlyPage } from "@/features/monthly"

type CalculatorType = "daily" | "weekly" | "monthly"

const VALID_TYPES: CalculatorType[] = ["daily", "weekly", "monthly"]
const DEFAULT_TYPE: CalculatorType = "daily"

export default function CalculatorPage() {
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const typeParam = searchParams.get("type")?.toLowerCase()

  // Check if using old URL format (/daily, /weekly, /monthly)
  const pathType = location.pathname.replace("/", "").toLowerCase()

  // Determine calculator type from query param OR path
  let calculatorType: CalculatorType = DEFAULT_TYPE

  if (typeParam && VALID_TYPES.includes(typeParam as CalculatorType)) {
    calculatorType = typeParam as CalculatorType
  } else if (pathType && VALID_TYPES.includes(pathType as CalculatorType)) {
    calculatorType = pathType as CalculatorType
  }

  // Render the appropriate calculator
  switch (calculatorType) {
    case "daily":
      return <DailyPage />
    case "weekly":
      return <WeeklyPage />
    case "monthly":
      return <MonthlyPage />
  }
}
